module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_8011.3f29673b.png";